import { TEXT_LIGHT, TEXT_DARK, BRAND_COLORS } from "@montana/constants/colors";
import { colorIsDark, perceivedBrightness } from "./color-brightness.helper";
import { lighten, darken, parseToHsla, mix, saturate } from 'color2k';

interface IBrandTextColorRelations {
    [k: string]: string;
}

const brandTextColorRelations: IBrandTextColorRelations = Object.keys(BRAND_COLORS)
    .reduce((obj, key) => {
        obj[BRAND_COLORS[key].color] = BRAND_COLORS[key].text;
        return obj;
    }, {} as IBrandTextColorRelations);

export const getTextColorFor = (hex: string) => {
    // We need accept hex value both with and without '#'
    const color = `#${hex.replace('#', '')}`;
    if (brandTextColorRelations[color]) {
        return brandTextColorRelations[color];
    }
    return colorIsDark(color) ? TEXT_LIGHT : TEXT_DARK;
}

/**
 * Darkens or lightens dynamically. Geared to always return a result close to what a designer would pick.
 * Under the hood: Darkens/lightens based on exisiting perceived luminance + adds a bit of saturation.
 *
 * @param {string} color
 * @return hex color
 */
export const getHoverColorFor = (color: string): string => {
    const [, saturation] = parseToHsla(color);

    const darkThreshold = 0.25;
    const pBrightness = perceivedBrightness(color);

    if (pBrightness < darkThreshold) {
        const addWhenDark = 0.1 * (1 - pBrightness / darkThreshold);
        return lighten(color, 0.1 + addWhenDark);
    }

    if (saturation > 0.7) {
        return saturate(mix(color, '#000', 0.2), 0.2);
    }

    return darken(color, 0.1);
}
